import axios from "@/plugins/axios";

export default {
  getEmailArchives(clientId, extraQuery) {
    return axios.get(`/client_email_archives/${clientId}`, {
      params: { query: extraQuery },
    });
  },
};
